/// <amd-module name="SuiteCommerce.ShippingBar.HeaderShippingBar.Text.View"/>
define("SuiteCommerce.ShippingBar.HeaderShippingBar.Text.View", ["require", "exports", "Backbone", "SuiteCommerce.ShippingBar.Instrumentation", "suitecommerce_shippingbar_header_text.tpl", "SuiteCommerce.ShippingBar.Common.Utils"], function (require, exports, Backbone_1, Instrumentation_1, suitecommerce_shippingbar_header_text_tpl, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.HeaderText = Backbone_1.View.extend({
        template: suitecommerce_shippingbar_header_text_tpl,
        title: Utils_1.Utils.translate('sc-shippingbar-header-text'),
        events: {
            'click [data-action = "click-header-bar-message"]': 'logMessageClick',
        },
        initialize: function (options) {
            this.model = options.model;
            this.messagesList = [
                {
                    message: this.model.getMessage('headerInitialMessage', 0),
                    link: this.model.get('barUrlLink'),
                    isActive: false,
                },
                {
                    message: this.model.getMessage('headerMessageAlt1', 0),
                    link: this.model.get('barUrlLinkAlt1'),
                    isActive: false,
                },
                {
                    message: this.model.getMessage('headerMessageAlt2', 0),
                    link: this.model.get('barUrlLinkAlt2'),
                    isActive: false,
                },
            ].filter(function (object) {
                return object.message !== (undefined || '');
            });
            this.render();
        },
        getContext: function () {
            this.resetList();
            this.messagesList[this.model.get('headerMessageIndex')].isActive = true;
            return {
                messagesList: this.messagesList,
            };
        },
        resetList: function () {
            this.messagesList.forEach(function (object) {
                return object.isActive = false;
            });
        },
        logMessageClick: function (element) {
            var messagesList = [
                'Initial message',
                'Alternate message 1',
                'Alternate message 2',
            ];
            var elem = element.currentTarget.classList[1];
            var log = Instrumentation_1.default.getLog('usage');
            log.setParameters({
                activity: "click on " + messagesList[Number(elem)] + " link",
            });
            log.submit();
        },
    });
});
